// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@tcp/core/src/components/common/hoc/withErrorBoundary';
import Image from '@tcp/core/src/components/common/atoms/Image';
import Anchor from '@tcp/core/src/components/common/atoms/Anchor';
import { getAPIConfig, getIconPath } from '@tcp/core/src/utils/utils';
import { currencyConversion } from '@tcp/core/src/components/features/CnC/CartItemTile/utils/utils';
import useHasMounted from '@tcp/core/src/hooks/useHasMounted';
import {
  getLabelFromCopyOrFromTranslation,
  renderLabel,
  getDynamicLabelValues,
} from '@tcp/core/src/utils/labels/labelUtilty';
import {
  GENERIC_GLOBAL,
  globalGenericLabels,
  PDP_PLCC_LABELS,
  pdpPLCCBannerLabelsData,
  pdpSubLabels,
} from './PlccWrapperStatic.labels';

const PlccWrapperStatic = (props) => {
  const genericLabelsObj = getLabelFromCopyOrFromTranslation(GENERIC_GLOBAL, globalGenericLabels);
  const dynamicBrowseLabels = getDynamicLabelValues('dynamic.browse_d');
  const pdpLabels = getLabelFromCopyOrFromTranslation('ProductDetailPage.PDP_Sub', pdpSubLabels);

  const plccBannerMY = renderLabel(pdpLabels.lbl_plcc_banner_my, 'lbl_plcc_banner_my');

  const plccBannerPlace = renderLabel(pdpLabels.lbl_plcc_banner_place, 'lbl_plcc_banner_place');

  const plccBannerSave30 = renderLabel(
    dynamicBrowseLabels.lbl_plcc_banner_save30,
    'lbl_plcc_banner_save30'
  );

  const plccBannerDescription = renderLabel(
    pdpLabels.lbl_plcc_banner_discription,
    'lbl_plcc_banner_discription'
  );

  const plccBannerRewards = renderLabel(
    pdpLabels.lbl_plcc_banner_rewards,
    'lbl_plcc_banner_rewards'
  );

  const plccBannerDesriptionOpen = renderLabel(
    pdpLabels.lbl_plcc_banner_discription_open,
    'lbl_plcc_banner_discription_open'
  );

  const plccBannerBrandImagePath = renderLabel(
    dynamicBrowseLabels.lbl_plcc_brand_image_path_pjp,
    'lbl_plcc_brand_image_path_pjp'
  );

  const plccBannerPay = renderLabel(pdpLabels.lbl_plcc_banner_pay, 'lbl_plcc_banner_pay');

  const plccBannerDesc = renderLabel(pdpLabels.lbl_plcc_banner_desc, 'lbl_plcc_banner_desc');

  const plccBannerTermsApply = renderLabel(
    dynamicBrowseLabels.lbl_plcc_banner_terms_apply,
    'lbl_plcc_banner_terms_apply'
  );

  const creditCardlabel = renderLabel(genericLabelsObj.lbl_creditCard, 'lbl_creditCard');
  const learnMoreLabel = renderLabel(genericLabelsObj.lbl_learnMore, 'lbl_learnMore');
  const pdpPLCCBannerLabels = getLabelFromCopyOrFromTranslation(
    PDP_PLCC_LABELS,
    pdpPLCCBannerLabelsData
  );
  const {
    openModal,
    prices,
    currencyAttributes,
    isPlccPriceOnPDP,
    isPDPRedesignEnabled,
    isPLCCBannerPriceEnabled,
    productOfferPrice,
    plccOfferPercentage,
  } = props;
  const hasMounted = useHasMounted();
  const { assetHostTCP } = getAPIConfig();
  const offerPrice = currencyConversion(prices?.offerPrice, currencyAttributes);
  const getSeventyPercent = prices?.offerPrice * 0.7;
  const plccCardPath = `${assetHostTCP}${plccBannerBrandImagePath}`;
  const plccOfferLabel = pdpPLCCBannerLabels.plccc_banner_text_pdp;

  const plccOfferPlaceholder = '#plccOfferPercentage#';
  const plccOfferPercentageLabel = () => {
    return plccOfferLabel?.replace(plccOfferPlaceholder, plccOfferPercentage || 30);
  };
  const plccBannerLabel = () => {
    if (plccBannerSave30?.includes(plccOfferPlaceholder)) {
      return plccBannerSave30?.replace(plccOfferPlaceholder, plccOfferPercentage);
    }
    return plccBannerSave30;
  };

  const plccOfferPercentageValue = (100 - (plccOfferPercentage || 30)) / 100;
  if (isPDPRedesignEnabled) {
    const plccProductOfferPrice = productOfferPrice * (plccOfferPercentageValue || 0.7);
    return (
      <div className="promotion-section-pdp-wrapper">
        <div className="promotion-section-pdp-icon plcc-discounted-price">
          {isPLCCBannerPriceEnabled ? (
            `$${plccProductOfferPrice.toFixed(2)}`
          ) : (
            <Image src={getIconPath('plcc_cc_icon')} />
          )}
        </div>
        <Anchor
          className="promotion-section-pdp-text"
          onClick={openModal}
          noLink
          href="#"
          anchorVariation="primary"
          dataLocator="Learn More"
          target="_self"
          aria-label="Learn more"
        >
          <div className="promotion-section-pdp-text">
            <span>{plccOfferPercentageLabel()}</span>{' '}
            <span
              dangerouslySetInnerHTML={{ __html: pdpPLCCBannerLabels.lbl_PLCC_reward_multiclr }}
            />{' '}
            <span>{creditCardlabel}</span>
          </div>
        </Anchor>
        <Anchor
          className="promotion-section-pdp-left-arrow"
          onClick={openModal}
          noLink
          href="#"
          anchorVariation="primary"
          dataLocator="Learn More"
          target="_self"
          aria-label="Learn more"
        >
          <Image src={getIconPath('right-arrow-plcc')} />
        </Anchor>
      </div>
    );
  }

  return (
    <div className="hardcoded-plcc-wrapper">
      <Image className="hardcoded-plcc image" src={plccCardPath} alt="plcc" />
      <Anchor
        className="hardcoded-plcc-anchor plcc-text-wrapper"
        onClick={openModal}
        noLink
        href="#"
        anchorVariation="primary"
        dataLocator="Learn More"
        target="_self"
        aria-label="Learn more"
      >
        {hasMounted && isPlccPriceOnPDP && getSeventyPercent && offerPrice ? (
          <span>
            <span className="hardcoded-plcc-text text1">{plccBannerPay}</span>{' '}
            <span className="plcc-list-price">${offerPrice}</span>{' '}
            <span className="plcc-offer-price"> ${getSeventyPercent.toFixed(2)} </span>{' '}
            {plccBannerDesc}
          </span>
        ) : (
          <p>
            <span className="hardcoded-plcc-text text1">{plccBannerLabel()}</span>{' '}
            {plccBannerDescription}{' '}
          </p>
        )}
        <span className="hardcoded-plcc-text-wrapper">
          {' '}
          {plccBannerDesriptionOpen}{' '}
          <span className="hardcoded-plcc-text text7">
            <span className="hardcoded-plcc-text text2">{plccBannerMY}</span>{' '}
            <span className="hardcoded-plcc-text text3">{plccBannerPlace}</span>{' '}
            <span className="hardcoded-plcc-text text4">{plccBannerRewards}</span>{' '}
            <span className="hardcoded-plcc-text text5">{creditCardlabel}</span>
            {hasMounted && isPlccPriceOnPDP && <span>{plccBannerTermsApply}</span>}{' '}
            <span className="hardcoded-plcc-text text6">{learnMoreLabel}</span>
          </span>
        </span>
      </Anchor>
    </div>
  );
};

PlccWrapperStatic.propTypes = {
  openModal: PropTypes.func,
  currencyAttributes: PropTypes.shape({}),
};

PlccWrapperStatic.defaultProps = {
  currencyAttributes: {
    exchangevalue: 1,
  },
  openModal: () => {},
};

export default errorBoundary(PlccWrapperStatic);
